<template>
  <mf-loading-dialog :loading="isLoadingCampaign">
    <base-page-layout title="Resultados da campanha">
      <template v-if="['ACTIVE', 'FINISHED'].includes(benefit.status)" v-slot:title-complement>
        <div v-if="benefit.status === 'ACTIVE'" class="pl-3">
          <mf-button label="Editar o cupom" outlined text-transform="none" icon="edit" icon-position="left" @click="emitEditFunction" />
        </div>
        <div class="pl-3">
          <mf-button label="Ver histórico de utilização" outlined text-transform="none" icon="history" icon-position="left" @click="emitHistoryFunction" />
        </div>
      </template>
      <div class="results-container">
        <info-card />
        <current-distribution v-if="status === 'ACTIVE'" />
        <general-results />
        <units-table :loading="isLoadingMetrics" />
        <products-table v-if="productsEnabled" :loading="isLoadingMetrics" />
        <mf-action-buttons
          v-if="!isFranchisee"
          class="mt-2"
          :primary-button="{
            text: 'Duplicar',
            action: cloneBenefitAction,
            isVisible: true,
            isLoading: loadingPrimaryButton,
          }"
          :cancel-button="{
            text: 'Fechar',
            action: returnToCampaigns,
            isVisible: true,
            isDisabled: false,
          }"
        />
      </div>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import InfoCard from '../components/results/InfoCard.vue'
import GeneralResults from '../components/results/GeneralResults.vue'
import UnitsTable from '../components/results/UnitsTable.vue'
import ProductsTable from '../components/results/ProductsTable.vue'
import { couponDiscount } from '../../mixins/coupon-discount'

import { getStatusLabel, getPeriod, floatToPercentString, putEmptyValue } from '@/config/helpers.js'
import CurrentDistribution from '../components/results/CurrentDistribution.vue'
export default {
  name: 'CouponCampaignResults',
  components: {
    BasePageLayout,
    InfoCard,
    GeneralResults,
    UnitsTable,
    ProductsTable,
    CurrentDistribution,
  },
  mixins: [couponDiscount],
  data: () => ({
    benefitId: null,
    isLoadingCampaign: false,
    isLoadingMetrics: false,
    loadingPrimaryButton: false,
    productsEnabled: false,
    status: null,
  }),
  computed: {
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
  },
  watch: {},
  mounted() {
    this.benefitId = this.$route.params.id
    // this.benefitId = '654e63142075cf327adfbd97'
    this.waitAndGetData()
  },
  methods: {
    getPeriod,
    getStatusLabel,
    floatToPercentString,
    putEmptyValue,
    returnToCampaigns() {
      this.$router.push('/campanhas/cupom-desconto')
    },
    async waitAndGetData() {
      this.isLoadingCampaign = true
      this.isLoadingMetrics = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(async () => {
        await this.getBenefitMetricsById({ id: this.benefitId, franchise: this.isFranchisee })
        await this.getBenefitDistribution({ input: { id: this.benefitId, franchise: this.isFranchisee } })
        this.status = this.benefit.status
        this.productsEnabled = this.benefit.productsEnabled
        this.isLoadingCampaign = false
        this.isLoadingMetrics = false
      }, 500)
    },
    async cloneBenefitAction() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: 'Deseja duplicar esta campanha?',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loadingPrimaryButton = true
      try {
        const cloneId = await this.cloneBenefit({
          input: { id: this.benefitId },
        })
        this.$router.push(`/campanhas/cupom-desconto/${cloneId}`).catch(() => {})
      } catch (error) {
        console.error(error)
        this.loadingPrimaryButton = false
        this.$snackbar(this.$t('campanhas.snackbars.errors.clone'))
      }
    },
    emitEditFunction() {
      const route = this.$router.resolve({ name: 'cupom-desconto-editar', params: { id: this.benefit._id } })
      window.open(route.href, '_blank')
    },
    emitHistoryFunction() {
      const route = this.$router.resolve({ name: 'cupom-historico-utilizacao', params: { id: this.benefit._id } })
      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.results-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
